(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[21],{

/***/ "2ejy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return track; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("d1HQ");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("829J");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




function track(props, appContext) {
  if (Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(props)) {
    return false;
  }

  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_2__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _tracking_constants__WEBPACK_IMPORTED_MODULE_3__[/* GA_DEFAULT_PAYLOAD */ "i"]), props), appContext);
}

/***/ }),

/***/ "54uq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_AVAILABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return API_VALIDATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_ACTIVATED; });
/* unused harmony export API_EDITABLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return API_UNAVAILABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_NOTYET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return API_UNEDITABLE; });
/* unused harmony export API_OPTION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return API_RESORT_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return API_UPSELL_AVAILABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return API_RESORT_ONLY_FORM_SENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_DONE; });
var API_AVAILABLE = 'AVAILABLE';
var API_VALIDATED = 'VALIDATED';
var API_ACTIVATED = 'ACTIVATED';
var API_EDITABLE = 'EDITABLE';
var API_UNAVAILABLE = 'UNAVAILABLE';
var API_NOTYET = 'NOT_YET';
var API_UNEDITABLE = 'UNEDITABLE';
var API_OPTION = 'OPTION';
var API_RESORT_ONLY = 'RESORT_ONLY';
var API_RESORT_ONLY_FORM_SENT = 'RESORT_ONLY_FORM_SENT';
var API_UPSELL_AVAILABLE = 'UPSELL_AVAILABLE';
var API_DONE = 'DONE';


/***/ }),

/***/ "C9cF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IS_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IS_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProductBadgeIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getServiceAgesLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getServiceAgesLabelTranslateOptions; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _color_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UCZK");


var IS_DISABLED = 'isDisabled';
var IS_ENABLED = 'isEnabled';
var IS_SELECTED = 'isSelected';

var getProductBadgeIcon = function getProductBadgeIcon(_ref) {
  var badgeIcon = _ref.badgeIcon,
      color = _ref.color,
      comfortLabel = _ref.comfortLabel;
  return {
    alt: comfortLabel || '',
    color: _color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WHITE,
    colorBg: color,
    colorBorder: color,
    iconName: badgeIcon
  };
};

function getServiceAgesLabel(ageInMonths, i18n) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["messageFormat"])(i18n.booking.services.childcare.kidsAgeInYears).format({
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    });
  }

  if (min < 23 && max && max > 23) {
    return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["messageFormat"])(i18n.booking.services.childcare.kidsAgeInMonthsAndYears).format({
      min: min,
      max: Math.floor(max / 12)
    });
  }

  return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["messageFormat"])(i18n.booking.services.childcare.kidsAgeInMonths).format({
    min: min,
    max: max
  });
}

function getServiceAgesLabelTranslateOptions(ageInMonths) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return ['booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    }];
  }

  if (min < 23 && max && max > 23) {
    return ['booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12)
    }];
  }

  return ['booking.services.childcare.kidsAgeInMonths', {
    min: min,
    // $FlowFixMe 🤬
    max: max
  }];
}



/***/ }),

/***/ "FpW3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_booking_payment_status_bookingPaymentStatus_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ycRU");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Ub5k");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_button_Button_jsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0__["createElement"];








var defaultProps = {
  dataSelector: 'BookingPaymentStatus'
};

function BookingPaymentStatus(_ref) {
  var className = _ref.className,
      dataSelector = _ref.dataSelector,
      isBookingPaid = _ref.isBookingPaid,
      shouldProposeOnlinePayment = _ref.shouldProposeOnlinePayment,
      status = _ref.status,
      bookingPaidLabel = _ref.bookingPaidLabel,
      bookingStatusLink = _ref.bookingStatusLink,
      children = _ref.children,
      onClick = _ref.onClick;
  var app = react__WEBPACK_IMPORTED_MODULE_0__["useContext"](_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]);
  var isBookingValidated = status === _utils_booking_payment_status_bookingPaymentStatus_constants__WEBPACK_IMPORTED_MODULE_2__[/* BOOKING_PAYMENT_STATUS_VALIDATED */ "f"];

  if (isBookingPaid && isBookingValidated) {
    return __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('BookingPaymentStatus', className),
      "data-selector": dataSelector
    }, __jsx("p", {
      className: "flex items-center"
    }, __jsx("span", {
      className: "BookingPaymentStatus--payed"
    }, bookingPaidLabel), __jsx(_frameworks_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
      className: "bg-emerald p-px10 rounded-half",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].WHITE,
      name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].CHECK,
      width: "1.875rem"
    })));
  }

  if (!shouldProposeOnlinePayment || !app.canUseOnlinePayment) {
    return null;
  }

  if (bookingStatusLink) {
    return __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('BookingPaymentStatus', className),
      "data-selector": dataSelector
    }, __jsx(_frameworks_button_Button_jsx__WEBPACK_IMPORTED_MODULE_6__[/* Button */ "a"], {
      dataSelector: "".concat(String(dataSelector), "-button"),
      url: bookingStatusLink.url,
      colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].BOOKING,
      colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].BOOKING,
      onClick: onClick,
      dataTestId: "".concat(String(dataSelector), "--button")
    }, bookingStatusLink.label));
  }

  if (children) {
    return __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('BookingPaymentStatus', className),
      "data-selector": dataSelector
    }, children);
  }

  return null;
}

BookingPaymentStatus.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (BookingPaymentStatus);

/***/ }),

/***/ "PEpN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkPropertiesForAppDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkPropertiesForEasyArrival; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return checkPropertiesForPickMyRoom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isPickMyRoomChecked; });
/* unused harmony export getEasyArrivalInfos */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDateDiff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDurationDiff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPropsForEasyArrival; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getPropsForAppDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return pluralizeLabel; });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("L7OA");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("L73y");
/* harmony import */ var _utils_api_status_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("54uq");







function pluralizeLabel(singularLabel, pluralLabel, amount) {
  return amount > 1 ? pluralLabel : singularLabel;
}

function getDateDiff(startDate, endDate) {
  if (!startDate) {
    return 0;
  }

  var startMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_3__[/* momentFromApiDate */ "h"])(startDate);
  var endMoment = endDate ? Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_3__[/* momentFromApiDate */ "h"])(endDate) : moment__WEBPACK_IMPORTED_MODULE_0___default()();
  return endMoment.diff(startMoment, 'days');
}

function getDiffResult(duration, type) {
  var result = Math.floor(Math.abs(duration));
  return result && {
    value: result,
    unit: type
  };
}

function getDuration(startDate, endDate) {
  var startMoment = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_4__[/* momentFromUTCDateTime */ "f"])(startDate);
  var endMoment = endDate ? Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_4__[/* momentFromUTCDateTime */ "f"])(endDate) : moment__WEBPACK_IMPORTED_MODULE_0___default()();
  return moment__WEBPACK_IMPORTED_MODULE_0___default.a.duration(endMoment.diff(startMoment));
}

function getDurationDiff(startDate, endDate) {
  var duration = getDuration(startDate, endDate);
  var defaultDiff = {
    value: 1,
    unit: 'minute'
  };
  var durationDays = getDiffResult(duration.asDays(), 'day');
  var diffDays = durationDays && durationDays.value > 2 ? durationDays : 0;
  return diffDays || getDiffResult(duration.asHours(), 'hour') || getDiffResult(duration.asMinutes(), 'minute') || defaultDiff;
}

function getEasyArrivalInfos(easyArrivalConfig, status) {
  var easyArrivalInfos = {
    NOT_YET: {
      text: easyArrivalConfig.soonText
    },
    AVAILABLE: {
      text: easyArrivalConfig.availableText,
      linkLabel: easyArrivalConfig.availableLinkLabel
    },
    UNEDITABLE: {
      text: easyArrivalConfig.tooLateText,
      linkLabel: easyArrivalConfig.tooLateLinkLabel
    },
    MAX_QUOTA_REACHED: {
      text: easyArrivalConfig.servicesFullyBookedText,
      linkLabel: easyArrivalConfig.availableLinkLabel
    }
  };
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["has"])(easyArrivalInfos, status) ? easyArrivalInfos[status] : null;
}

function checkPropertiesForEasyArrival(easyArrival, config) {
  var easyArrivalConfig = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(config, 'memberSpace.easyArrival', null);
  var easyArrivalBooking = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(easyArrival, 'status');
  return !Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(easyArrivalConfig) && easyArrivalBooking !== _utils_api_status_constants__WEBPACK_IMPORTED_MODULE_5__[/* API_UNAVAILABLE */ "g"] && easyArrivalBooking !== 'UNAVAILABLE_FOR_THIS_COUNTRY';
}

function getPropsForEasyArrival(easyArrival, easyArrivalConfig) {
  var toDisplay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var easyArrivalInfos = toDisplay && !Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(easyArrivalConfig) ? getEasyArrivalInfos(easyArrivalConfig, Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(easyArrival, 'status')) : null;
  return easyArrivalInfos && {
    headerLabel: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(easyArrivalConfig, 'title'),
    image: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(easyArrivalConfig, 'image'),
    texts: [Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(easyArrivalConfig, 'subtitle'), Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(easyArrivalInfos, 'text')],
    link: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(easyArrival, 'href'),
    linkLabel: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(easyArrivalInfos, 'linkLabel')
  };
}

function getPropsForAppDownload(stay, cmsContent) {
  var url = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(stay, 'appUrl');
  return {
    title: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(cmsContent, 'memberSpace.prepareMyStay.downloadResortsApp.dashboardBlock.title'),
    description: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(cmsContent, 'memberSpace.prepareMyStay.downloadResortsApp.dashboardBlock.description'),
    buttonLabel: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(cmsContent, 'memberSpace.prepareMyStay.downloadResortsApp.dashboardBlock.downloadButtonLabel'),
    url: url
  };
}

function checkPropertiesForAppDownload(stay, cmsContent) {
  var url = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(stay, 'appUrl');
  var displayDownload = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(cmsContent, 'memberSpace.prepareMyStay.downloadResortsApp.displayDownload');
  var difference = getDateDiff(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(stay, 'departureDate')) * -1;
  return !!(stay && stay.resort && stay.resort.hasMobileApp && url && displayDownload && difference < 35);
}

var checkPropertiesForPickMyRoom = function checkPropertiesForPickMyRoom(appContext) {
  var getFeatureFlipValue = Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_2__[/* isFeatureFlipped */ "a"])(appContext);
  return function (status) {
    var statuses = [_utils_api_status_constants__WEBPACK_IMPORTED_MODULE_5__[/* API_AVAILABLE */ "b"], _utils_api_status_constants__WEBPACK_IMPORTED_MODULE_5__[/* API_VALIDATED */ "j"], _utils_api_status_constants__WEBPACK_IMPORTED_MODULE_5__[/* API_ACTIVATED */ "a"]];

    if (getFeatureFlipValue('pickYourRoom.resortOnlyRequestForm')) {
      statuses.push(_utils_api_status_constants__WEBPACK_IMPORTED_MODULE_5__[/* API_RESORT_ONLY */ "e"]);
    }

    return getFeatureFlipValue('pickYourRoom.allow') && statuses.includes(status);
  };
};

function isPickMyRoomChecked(status) {
  return [_utils_api_status_constants__WEBPACK_IMPORTED_MODULE_5__[/* API_VALIDATED */ "j"], _utils_api_status_constants__WEBPACK_IMPORTED_MODULE_5__[/* API_ACTIVATED */ "a"]].includes(status);
}



/***/ }),

/***/ "VHif":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Badge_Badge; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.themes.js

var variants = {
  diamond: {
    root: ' rotate-45',
    item: ' -rotate-45'
  },
  pill: {
    root: ' rounded-full',
    item: ''
  }
};
var themes = {
  "default": function _default(_ref) {
    var _ref$colorBg = _ref.colorBg,
        colorBg = _ref$colorBg === void 0 ? colors["a" /* COLORS */].BLUE : _ref$colorBg,
        _ref$colorBorder = _ref.colorBorder,
        colorBorder = _ref$colorBorder === void 0 ? colors["a" /* COLORS */].BLUE : _ref$colorBorder,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref$color,
        hasShadow = _ref.hasShadow,
        variant = _ref.variant;
    return {
      thRoot: "bg-".concat(colorBg, " border-").concat(colorBorder, " text-").concat(color, " border-2 flex-none inline-flex items-center justify-center leading-none overflow-hidden relative").concat(hasShadow ? ' shadow' : '').concat(variant ? variants[variant].root : ''),
      thImage: "absolute inset-0 ".concat(variant ? variants[variant].item : ''),
      thIcon: "absolute flex items-center justify-center inset-0".concat(variant ? variants[variant].item : ''),
      thIconSize: '65%',
      thLabel: "absolute flex items-center justify-center leading-tight overflow-hidden inset-0 text-center ".concat(variant ? variants[variant].item : ''),
      thLabelStyle: {
        fontSize: '1em'
      }
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.jsx
var __jsx = react_default.a.createElement;





var Badge_Badge = function Badge(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      colorBg = _ref.colorBg,
      colorBorder = _ref.colorBorder,
      color = _ref.color,
      hasShadow = _ref.hasShadow,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      imageSrc = _ref.imageSrc,
      label = _ref.label,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 50 : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      variant = _ref.variant;

  if (!iconName && !imageSrc && !label) {
    return null;
  }

  var _themes$theme = themes[theme]({
    colorBg: colorBg,
    colorBorder: colorBorder,
    color: color,
    hasShadow: hasShadow,
    variant: variant
  }),
      thIcon = _themes$theme.thIcon,
      thIconSize = _themes$theme.thIconSize,
      thImage = _themes$theme.thImage,
      thLabel = _themes$theme.thLabel,
      thLabelStyle = _themes$theme.thLabelStyle,
      thRoot = _themes$theme.thRoot;

  var styles = {
    width: size,
    height: size
  };
  var imageSize = {
    w: size,
    h: size
  };
  return __jsx("div", {
    className: classnames_default()(className, thRoot),
    style: styles
  }, !!imageSrc && __jsx("div", {
    className: thImage
  }, __jsx(Image["b" /* default */], {
    altMsg: alt,
    forceImage: true,
    imageUrl: imageSrc,
    mandatoryWidthAndHeight: imageSize
  })), !!iconName && __jsx("div", {
    className: thIcon
  }, __jsx(Icon["a" /* Icon */], {
    alt: alt,
    name: iconName,
    width: iconSize || thIconSize
  })), !!label && __jsx("div", {
    className: thLabel,
    style: thLabelStyle
  }, label));
};

/***/ }),

/***/ "blgx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_STATUS_ARCHIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BOOKING_STATUS_VALIDATED; });
/* unused harmony export BOOKING_STATUS_CANCELED */
/* unused harmony export BOOKING_STATUS_QUOTATION */
/* unused harmony export BOOKING_STATUS_HOPE */
/* unused harmony export BOOKING_STATUS_EXPIRED_OPTION */
/* unused harmony export BOOKING_STATUS_EXPIRED_HOPE */
/* unused harmony export BOOKING_STATUS_EXPIRED_QUOTATION */
/* unused harmony export BOOKING_STATUS_REQUEST */
var BOOKING_STATUS_VALIDATED = 'VALIDATED';
var BOOKING_STATUS_CANCELED = 'CANCELED';
var BOOKING_STATUS_QUOTATION = 'QUOTATION';
var BOOKING_STATUS_HOPE = 'HOPE';
var BOOKING_STATUS_EXPIRED_OPTION = 'EXPIRED_OPTION';
var BOOKING_STATUS_EXPIRED_HOPE = 'EXPIRED_HOPE';
var BOOKING_STATUS_EXPIRED_QUOTATION = 'EXPIRED_QUOTATION';
var BOOKING_STATUS_REQUEST = 'REQUEST';
var BOOKING_STATUS_ARCHIVED = 'ARCHIVED';


/***/ }),

/***/ "vakO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("U2CP");
/* harmony import */ var _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _booking_payment_status_bookingPaymentStatus_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ycRU");
/* harmony import */ var _booking_status_bookingStatus_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("blgx");
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ldK3");










function formatPhoneNumber(agencyPhoneNumber) {
  return agencyPhoneNumber && "tel:".concat(agencyPhoneNumber.replace(/\s/g, ''));
}

function getPhoneNumber(vendor, fallbackPhoneNumber) {
  return vendor && (vendor.isSoldByClubMed && !vendor.phoneNumber ? fallbackPhoneNumber : vendor.phoneNumber);
}

function getAgencyLabel(vendor, cmsContent) {
  var pleaseContactClubMedLabel = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(cmsContent, 'pleaseContactClubMedLabel', null);
  var pleaseContactExternalLabel = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(cmsContent, 'pleaseContactExternalLabel', null);
  return vendor && (vendor.isSoldByClubMed ? pleaseContactClubMedLabel : pleaseContactExternalLabel && Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["messageFormat"])(pleaseContactExternalLabel).format({
    agencyName: vendor.name
  }));
}

function getAgencyDetails(_ref) {
  var vendor = _ref.vendor,
      travelAdvisor = _ref.travelAdvisor,
      dedicatedJoyviewHotlineNumber = _ref.dedicatedJoyviewHotlineNumber,
      isJoyview = _ref.isJoyview;
  var agencyPhoneNumber = isJoyview && !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(dedicatedJoyviewHotlineNumber) ? dedicatedJoyviewHotlineNumber : this.getPhoneNumber(vendor, Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(travelAdvisor, 'phoneNumber'));
  return {
    label: agencyPhoneNumber,
    url: this.formatPhoneNumber(agencyPhoneNumber)
  };
}

function isPastTrip(returnDate) {
  if (!returnDate) {
    return false;
  }

  return moment__WEBPACK_IMPORTED_MODULE_1___default()(Date.now()).isAfter(moment__WEBPACK_IMPORTED_MODULE_1___default()(returnDate, 'YYYYMMDD'));
}

function shouldDisplayPriceDetail(isSoldByClubMed, displayPriceDetail) {
  return isSoldByClubMed || displayPriceDetail;
}

function getPackageIcon(isAllInclusive, isJoyview) {
  var iconAccommodations = isJoyview ? _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].JOYVIEW_HAND : _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ACCOMODATIONS;
  return isAllInclusive ? _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ALL_INCLUSIVE : iconAccommodations;
}

function isOption(informationStatus) {
  return informationStatus === _booking_payment_status_bookingPaymentStatus_constants__WEBPACK_IMPORTED_MODULE_6__[/* BOOKING_PAYMENT_STATUS_OPTION */ "c"];
}

function isArchived(bookingStatus) {
  return bookingStatus === _booking_status_bookingStatus_constants__WEBPACK_IMPORTED_MODULE_7__[/* BOOKING_STATUS_ARCHIVED */ "a"];
}

function shouldDisplayLinkList(userBooking) {
  var currentUri = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new urijs__WEBPACK_IMPORTED_MODULE_2___default.a('#');
  var isFeatureFlippedOff = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var stay = arguments.length > 3 ? arguments[3] : undefined;
  var prepareMyStayDirectory = new urijs__WEBPACK_IMPORTED_MODULE_2___default.a(Object(_routes_routeBuilder__WEBPACK_IMPORTED_MODULE_4__[/* buildUrl */ "a"])('prepareMyStay', {
    bookingId: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(userBooking, 'information.bookingId')
  })).directory();
  var isOnPrepareMyStay = currentUri.directory() === prepareMyStayDirectory.toString();
  return !isOption(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(userBooking, 'information.status')) && !isPastTrip(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(stay, 'returnDate')) && !isFeatureFlippedOff || isOnPrepareMyStay;
}

function hasTransport(stay) {
  return !!(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(stay, 'departureCity') || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(stay, 'arrivalCity'));
}

function hasTransfer(transfers) {
  return !!(transfers && (!Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(transfers.inbound) || !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(transfers.outbound)));
}

function findStay(booking, stayId) {
  var stays = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(booking, 'information.stays', []);

  if (!stayId && stays.length === 1) {
    return stays[0];
  }

  return stays.find(function (s) {
    return s.id === stayId;
  });
}

function isFirstStay(booking, stayId) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(booking, 'information.stays.0', {}).id === stayId;
}

function findStayFormality(stayFormalities, stayId) {
  return (stayFormalities || []).find(function (s) {
    return s.stayId === stayId;
  });
}

function findTransferDetails(booking, stayId) {
  var stay = findStay(booking, stayId);
  if (!stay) return;
  return (Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(booking, 'transferDetails') || []).find(function (transfer) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(transfer, 'inbound.date') === (Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(stay, 'departureDate') || Number.NaN).toString() || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(transfer, 'outbound.date') === (Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(stay, 'returnDate') || Number.NaN).toString();
  });
}

function isMultiStay(booking) {
  var stays = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(booking, 'information.stays');
  return stays && stays.length > 1;
}

function findCurrentStay(booking) {
  var stays = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(booking, 'information.stays', []);
  if (stays.length === 0) return null;
  if (stays.length === 1) return stays[0];
  var now = moment__WEBPACK_IMPORTED_MODULE_1___default()();
  var res = stays.find(function (stay) {
    return stay.departureDate && stay.returnDate && Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_8__[/* momentFromApiDate */ "h"])(stay.departureDate).isBefore(now) && Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_8__[/* momentFromApiDate */ "h"])(stay.returnDate).isAfter(now);
  });
  return res || stays[0];
}

function isTour(stay) {
  return stay.productType === 'TOUR';
}

function isCruise(stay) {
  return stay.productType === 'CRUISE';
}

function getTranportIcon(transportType) {
  switch (transportType) {
    case 'TRAIN':
      return _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].TRAIN;

    case 'BOAT':
    case 'FERRY':
      return _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].BOAT;

    default:
      return _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].TRANSPORT;
  }
}

function isSoldByClubmed(vendor) {
  return vendor === 'CLUBMED';
}

/* harmony default export */ __webpack_exports__["a"] = ({
  formatPhoneNumber: formatPhoneNumber,
  getPhoneNumber: getPhoneNumber,
  getAgencyLabel: getAgencyLabel,
  getAgencyDetails: getAgencyDetails,
  getPackageIcon: getPackageIcon,
  isPastTrip: isPastTrip,
  shouldDisplayPriceDetail: shouldDisplayPriceDetail,
  shouldDisplayLinkList: shouldDisplayLinkList,
  hasTransport: hasTransport,
  hasTransfer: hasTransfer,
  isOption: isOption,
  isArchived: isArchived,
  findStay: findStay,
  isMultiStay: isMultiStay,
  findStayFormality: findStayFormality,
  findCurrentStay: findCurrentStay,
  isFirstStay: isFirstStay,
  findTransferDetails: findTransferDetails,
  isTour: isTour,
  isCruise: isCruise,
  getTranportIcon: getTranportIcon,
  isSoldByClubmed: isSoldByClubmed
});

/***/ }),

/***/ "ycRU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BOOKING_PAYMENT_STATUS_VALIDATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BOOKING_PAYMENT_STATUS_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BOOKING_PAYMENT_STATUS_PACKAGE_UPGRADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_PAYMENT_STATUS_ADDITIONAL_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BOOKING_PAYMENT_STATUS_PICK_YOUR_ROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BOOKING_PAYMENT_STATUS_CART; });
var BOOKING_PAYMENT_STATUS_VALIDATED = 'VALIDATED';
var BOOKING_PAYMENT_STATUS_OPTION = 'OPTION';
var BOOKING_PAYMENT_STATUS_PACKAGE_UPGRADE = 'PACKAGE_UPGRADE';
var BOOKING_PAYMENT_STATUS_ADDITIONAL_SERVICE = 'ADDITIONAL_SERVICE';
var BOOKING_PAYMENT_STATUS_PICK_YOUR_ROOM = 'PICK_YOUR_ROOM';
var BOOKING_PAYMENT_STATUS_CART = 'CART';


/***/ }),

/***/ "zgAg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TravelDetails; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/utils/ple-utils/bookingUtils.js
var bookingUtils = __webpack_require__("vakO");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/travel-details/travel-detail/TravelDetail.jsx
var __jsx = react_default.a.createElement;






function renderDetail(text, highlightText, style) {
  if (Object(lodash["isEmpty"])(text) && Object(lodash["isEmpty"])(highlightText)) {
    return null;
  }

  return __jsx("div", {
    className: "rtl:text-left",
    style: style
  }, __jsx("span", {
    "data-testid": "TravelDetail-label"
  }, text), __jsx("span", null, " "), __jsx("strong", {
    "data-testid": "TravelDetail-bold",
    className: "text-blue"
  }, highlightText));
}

function TravelDetail(props) {
  return __jsx("div", {
    className: "TravelDetail flex items-center py-px10 sm:justify-center sm:w-full"
  }, __jsx(Icon["a" /* Icon */], {
    className: "mx-px15 sm:m-0 md:mx-px10 align-top flex-shrink-0",
    color: colors["a" /* COLORS */].BLUE,
    name: props.icon,
    width: "1.75rem"
  }), !Object(lodash["isEmpty"])(props.infos) ? __jsx("div", {
    className: "mx-px10 w-full align-top sm:align-middle sm:w-auto",
    "data-testid": "TravelDetail-texts"
  }, renderDetail(Object(lodash["get"])(props, 'infos.text1'), Object(lodash["get"])(props, 'infos.highlightText1')), renderDetail(Object(lodash["get"])(props, 'infos.text2'), Object(lodash["get"])(props, 'infos.highlightText2'))) : null);
}
// CONCATENATED MODULE: ./src/client/components/widgets/travel-details/duration/DurationTravelDetails.jsx
var DurationTravelDetails_jsx = react_default.a.createElement;




var INITIAL_DATE_FORMAT = 'YYYYMMDD';
function DurationTravelDetails(props) {
  var departureDate = props.departureDate,
      returnDate = props.returnDate,
      dateFormat = props.dateFormat,
      fromLabel = props.fromLabel,
      toLabel = props.toLabel;
  return departureDate && returnDate ? DurationTravelDetails_jsx(TravelDetail, {
    infos: {
      text1: fromLabel,
      highlightText1: moment_default()(departureDate, INITIAL_DATE_FORMAT).format(dateFormat),
      text2: toLabel,
      highlightText2: moment_default()(returnDate, INITIAL_DATE_FORMAT).format(dateFormat)
    },
    icon: icons["a" /* ICONS */].DATE
  }) : null;
}
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/trips-summary/TripsSummaryUtils.js
var TripsSummaryUtils = __webpack_require__("PEpN");

// CONCATENATED MODULE: ./src/client/components/widgets/travel-details/participants/ParticipantsTravelDetails.jsx

var ParticipantsTravelDetails_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function getAdultsLabel(_ref) {
  var number = _ref.number,
      _ref$labels = _ref.labels,
      labels = _ref$labels === void 0 ? {} : _ref$labels;
  var pluralizedLabel = Object(TripsSummaryUtils["i" /* pluralizeLabel */])(labels.label_1, labels.label_n, number);
  return "".concat(number, " ").concat(pluralizedLabel);
}

function getChildrenProps(_ref2) {
  var number = _ref2.number,
      _ref2$labels = _ref2.labels,
      labels = _ref2$labels === void 0 ? {} : _ref2$labels;
  var pluralizedLabel = Object(TripsSummaryUtils["i" /* pluralizeLabel */])(labels.label_1, labels.label_n, number);
  return number && !Object(lodash["isEmpty"])(labels) ? {
    text2: labels.and,
    highlightText2: "".concat(number, " ").concat(pluralizedLabel)
  } : null;
}

function ParticipantsTravelDetails(_ref3) {
  var adults = _ref3.adults,
      children = _ref3.children;
  return Object(lodash["get"])(adults, 'number', false) && !Object(lodash["isEmpty"])(adults.labels) ? ParticipantsTravelDetails_jsx(TravelDetail, {
    infos: _objectSpread({
      text1: Object(lodash["get"])(adults, 'labels.for'),
      highlightText1: getAdultsLabel(adults)
    }, getChildrenProps(children)),
    icon: icons["a" /* ICONS */].USERS
  }) : null;
}
// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// CONCATENATED MODULE: ./src/client/components/widgets/travel-details/transport/TransportTravelDetails.jsx
var TransportTravelDetails_jsx = react_default.a.createElement;







function formatCallToUpsellTransportLabel(_ref) {
  var vendor = _ref.vendor,
      travelAdvisor = _ref.travelAdvisor,
      isJoyview = _ref.isJoyview,
      labels = _ref.labels;
  var callToUpsellTransportLabel = Object(lodash["get"])(labels, 'transport.callToUpsellTransportLabel');
  var params = {
    vendor: vendor,
    travelAdvisor: travelAdvisor,
    isJoyview: isJoyview,
    dedicatedJoyviewHotlineNumber: labels.dedicatedJoyviewHotlineNumber
  };
  var agencyDetails = bookingUtils["a" /* default */].getAgencyDetails(params);
  return callToUpsellTransportLabel ? Object(dist["messageFormat"])(callToUpsellTransportLabel).format({
    agencyNumber: Object(lodash["get"])(agencyDetails, 'label', '')
  }) : '';
}

function TransportTravelDetails(props) {
  if (Object(lodash["isEmpty"])(props)) {
    return null;
  }

  var departureCity = props.departureCity,
      arrivalCity = props.arrivalCity,
      returnDate = props.returnDate,
      bookingStatus = props.bookingStatus,
      _props$labels = props.labels,
      labels = _props$labels === void 0 ? {} : _props$labels,
      transportType = props.transportType;
  var hasTransport = departureCity && arrivalCity;
  var isSearch = bookingStatus === 'SEARCH';

  if (!hasTransport) {
    var highlightText = bookingUtils["a" /* default */].isPastTrip(returnDate) || isSearch ? '' : formatCallToUpsellTransportLabel(props);
    return TransportTravelDetails_jsx(TravelDetail, {
      infos: {
        text1: labels.withoutTransport,
        highlightText2: highlightText
      },
      icon: icons["a" /* ICONS */].NO_TRANSPORT
    });
  }

  return TransportTravelDetails_jsx(TravelDetail, {
    infos: {
      text1: Object(lodash["get"])(labels, 'transport.from'),
      highlightText1: departureCity,
      text2: Object(lodash["get"])(labels, 'transport.to'),
      highlightText2: arrivalCity
    },
    icon: bookingUtils["a" /* default */].getTranportIcon(transportType)
  });
}
// CONCATENATED MODULE: ./src/client/components/widgets/travel-details/TravelDetails.jsx
var TravelDetails_jsx = react["createElement"];








function propsForTransportTravelDetails(config, vendor, bookingStatus) {
  var stay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    departureCity: stay.departureCity,
    arrivalCity: stay.arrivalCity,
    returnDate: stay.returnDate,
    bookingStatus: bookingStatus,
    isJoyview: Object(lodash["get"])(stay, 'resort.isJoyview'),
    vendor: vendor,
    travelAdvisor: Object(lodash["get"])(config, 'travelAdvisor'),
    labels: {
      transport: Object(lodash["get"])(config, 'memberSpace.trips.transport'),
      withoutTransport: Object(lodash["get"])(config, 'booking.form.withoutTransport'),
      dedicatedJoyviewHotlineNumber: Object(lodash["get"])(config, 'memberSpace.trips.dedicatedJoyviewHotlineNumber')
    },
    transportType: Object(lodash["get"])(stay, 'transportType')
  };
}

function TravelDetails(_ref) {
  var config = _ref.config,
      stay = _ref.stay,
      vendor = _ref.vendor,
      bookingStatus = _ref.bookingStatus,
      isVertical = _ref.isVertical;
  var cmsContent = Object(lodash["get"])(config, 'memberSpace', null);
  var isJoyview = Object(lodash["get"])(stay, 'resort.isJoyview');
  var isArchived = bookingUtils["a" /* default */].isArchived(bookingStatus);
  return cmsContent && stay ? TravelDetails_jsx("div", {
    className: classnames_default()('TravelDetails', {
      isVertical: Boolean(isVertical)
    })
  }, TravelDetails_jsx(DurationTravelDetails, {
    departureDate: Object(lodash["get"])(stay, 'departureDate'),
    returnDate: Object(lodash["get"])(stay, 'returnDate'),
    dateFormat: Object(lodash["get"])(config, 'memberSpace.trips.duration.dateFormat'),
    fromLabel: Object(lodash["get"])(config, 'memberSpace.trips.duration.from'),
    toLabel: Object(lodash["get"])(config, 'memberSpace.trips.duration.to')
  }), !isArchived && TravelDetails_jsx(ParticipantsTravelDetails, {
    adults: {
      number: Object(lodash["get"])(stay, 'adults', 0),
      labels: Object(lodash["get"])(config, 'memberSpace.trips.adults', {})
    },
    children: {
      number: Object(lodash["get"])(stay, 'children', 0),
      labels: Object(lodash["get"])(config, 'memberSpace.trips.children', {})
    }
  }), !isJoyview && TravelDetails_jsx(TransportTravelDetails, propsForTransportTravelDetails(config, vendor, bookingStatus, stay))) : null;
}

/***/ })

}]);